import { create } from 'zustand';

type FindingListNavigationState = {
  findingIds: string[];
  setFindingIds: (findingIds: string[]) => void;
  clearFindingIds: () => void;
};

export const useFindingListNavigationStore =
  create<FindingListNavigationState>()((set) => ({
    findingIds: [],
    setFindingIds: (findingIds) => set({ findingIds }),
    clearFindingIds: () => set({ findingIds: [] }),
  }));
